import React, { useEffect, useState } from "react";

// components
import { Button, Card, CardBody, CardHeader, Form, Row, Col, Spinner } from "reactstrap";
import MaterialTable from 'material-table';
import moment from 'moment';

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// views
import GrupoFDEFicha from "./GrupoFDEFicha.jsx";

// helpers
import { showMessage } from "../../../helpers/message.js";

// api
import grupofde_api from "../../../api/grupofde_api.js";

export default function GrupoFDELista() {

  const [showLoading, setshowLoading] = useState(false);

  const [list_table, set_list_table] = useState([]);
  const [rowEdit, set_rowEdit] = useState(null);
  const [showDetail, set_showDetail] = useState(false);

  const handleAdd = () => {
    set_rowEdit(null);
    set_showDetail(true);
  }

  const handleEdit = (rowData) => {
    setshowLoading(true);
    grupofde_api.getItem(rowData.grupoFDE_Id).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_rowEdit(result.data);
        set_showDetail(true);
      }
    });
  }

  const handleReturn = () => {
    set_rowEdit(null);
    set_showDetail(false);
    loadList();
  }

  const loadList = () => {
    setshowLoading(true);
    grupofde_api.getAll().then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  useEffect(() => {
    loadList();
  }, []);

  //Badge de status do próximo processamento (vencido / próximo / ok)
  const renderProximoProcessamento = (rowData) => {
    if (!rowData.proximoProcessamento)
      return <span className="badge badge-secondary">Nunca processado</span>;

    const hoje = moment().startOf('day');
    const data = moment(rowData.proximoProcessamento);
    const diasRestantes = data.diff(hoje, 'days');

    let classe = "badge-success";
    if (diasRestantes < 0) classe = "badge-danger";
    else if (diasRestantes <= 7) classe = "badge-warning";

    return <span className={`badge ${classe}`}>{data.format("DD/MM/YYYY")}</span>;
  }

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className={showDetail ? "d-none" : "content"}>
        <Row>
          <Col md="12">
            <Button color="default" onClick={handleAdd}><i className="fa fa-plus"></i>  Novo Grupo FDE</Button>
            <Card>
              <CardHeader>
                <h4 className="titleCard">Lista de Grupos FDE</h4>
              </CardHeader>
              <CardBody>
                <Form>
                  <MaterialTable style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                      { title: 'Identificação', field: 'identificacao' },
                      { title: 'Status', field: 'status' },
                      { title: 'Recorrência', field: 'recorrencia' },
                      { title: 'Próximo Processamento', field: 'proximoProcessamento', render: renderProximoProcessamento }
                    ]}
                    data={list_table}
                    isLoading={false}
                    options={{
                      ...table_style,
                      filtering: false,
                      exportButton: true
                    }}
                    actions={[
                      {
                        icon: 'search',
                        tooltip: 'Visualizar Registro',
                        onClick: (event, rowData) => handleEdit(rowData)
                      }
                    ]}
                    localization={table_translate}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showDetail &&
        <GrupoFDEFicha
          item={rowEdit}
          handleReturn={handleReturn}
        />
      }

    </>

  );
}
